import { getBrandConfig } from '../brand'

const brand = getBrandConfig()

export const ServiceIds = brand.serviceIds
export const SPORT_IDS = brand.sportIds

export const DEFAULT_USER_STATS = Object.freeze({
  streak: 0,
  airtimeWon: 0,
  top50Fantasy: 0,
  top50Predictor: 0
})

export function getSubscriptionFromGetUser(response) {
  const hasPremiumServiceId = response?.serviceId === ServiceIds.premium
  const isInterested = (response?.status || '').toLowerCase() === 'interested'
  const isSubscribed = hasPremiumServiceId && !isInterested
  const serviceId = hasPremiumServiceId ? ServiceIds.premium : ServiceIds.free
  const status = isSubscribed ? 'Active' : 'Pending'
  return { isSubscribed, serviceId, status }
}

export function transformUserApiResponse(apiResponse, fallbackStats = null) {
  if (!apiResponse?.success) return null

  const { isSubscribed, serviceId, status } = getSubscriptionFromGetUser(apiResponse)

  const subscriptionCategories = apiResponse.subscriptionCategories || []
  const activeSubscriptions = subscriptionCategories
    .filter(cat => cat.status === 1)
    .map(cat => `${cat.category}: true`)

  return {
    ...apiResponse,
    isSubscribed,
    status,
    serviceId,
    username: apiResponse.username || 'Guest',
    Subcriptions: activeSubscriptions.length > 0 ? activeSubscriptions : ['FreeUser: true'],
    subscriptionCategories,
    stats: apiResponse.stats || fallbackStats || DEFAULT_USER_STATS
  }
}

export default {
  ServiceIds,
  SPORT_IDS,
  DEFAULT_USER_STATS,
  getSubscriptionFromGetUser,
  transformUserApiResponse
}
